module.exports = __webpack_public_path__ + "img/4.31d9657a.jpg";